<div class="commission-settlement-details-view-container" *ngIf="commissionSettlementObject" fxLayout="column" fxLayoutGap="15px" >
  <div class="status-info">
    <mat-form-field appearance="fill" [ngClass]="'input-color-' + commissionSettlementObject.status.color">
      <mat-label>Status</mat-label>
      <input matInput placeholder="Status" [disabled]="true" [value]="commissionSettlementObject.status?.name">
    </mat-form-field>
  </div>

  <div fxLayout="row" fxLayoutGap="15px">
    <button
      (click)="downloadReport()"
      [disabled]="!(userPermissions | async).settlement.read_report"
      mat-raised-button class="report-button"
    ><mat-icon>download</mat-icon> <span> Raport ogólny</span></button>

    <button
      (click)="downloadDetailedReport()"
      [disabled]="!(userPermissions | async).settlement.read_report"
      mat-raised-button class="report-button"
    ><mat-icon>download</mat-icon> <span> Raport szczegółowy</span></button>

<!--    <button-->
<!--      (click)="generateCommissionSettlements()"-->
<!--      [disabled]="!(userPermissions | async).settlement.delete || commissionSettlementObject.status?.key !== COMMISSION_SETTLEMENT_STATUS_TO_GENERATE"-->
<!--      mat-raised-button class="report-button" color="primary"-->
<!--    ><mat-icon>refresh</mat-icon> <span> Generuj rozliczenie</span></button>-->
  </div>

  <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px">

    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">

      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Dane rozliczenia</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px" *ngIf="commissionSettlementObject.partner">
              <app-detail fxFlex="50" header="Strona umowy" value="Partner"></app-detail>

              <app-detail fxFlex="50" header="Partner" [value]="commissionSettlementObject.partner?.shortName"
                          [link]="commissionSettlementObject.partner ? ['/partnerzy/szczegoly', commissionSettlementObject.partner?.uuid] : undefined"></app-detail>
            </div>

            <div fxLayout="row" fxLayoutGap="15px" *ngIf="commissionSettlementObject.ofwca">
              <app-detail fxFlex="50" header="Strona umowy" value="OFWCA"></app-detail>

              <app-detail fxFlex="100" header="OFWCA" [value]="commissionSettlementObject.ofwca?.fullName"
                          [link]="['/ofwca/szczegoly', commissionSettlementObject.ofwca?.uuid]"></app-detail>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <app-detail fxFlex="50" header="Numer" [value]="commissionSettlementObject.number"></app-detail>

              <app-detail fxFlex="50" header="Miesiąc rozliczeniowy" [value]="commissionSettlementObject.billingMonth"></app-detail>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <app-detail fxFlex="50" header="Hasło do pliku" [value]="commissionSettlementObject?.partner ? commissionSettlementObject?.partner?.settlementPassword : commissionSettlementObject?.ofwca?.settlementPassword"></app-detail>

              <div fxFlex="50" fxLayoutAlign="center" >
                <button
                  (click)="sendPassword(commissionSettlementObject)"
                  [disabled]="!(userPermissions | async).settlement.read_report
                  || commissionSettlementObject.partner ? commissionSettlementObject.partner.settlementPassword === null : commissionSettlementObject.ofwca.settlementPassword === null"
                  mat-raised-button color="primary" class="send-password"
                ><mat-icon>send</mat-icon> <span> Wyślij hasło do pliku </span></button>
              </div>

            </div>

            <div fxLayout="column">
              <ng-container *ngFor="let element of logs">
                <ng-container *ngFor="let items of element.items; let i = index">
                  <ng-container *ngIf="items.log.entityId === commissionSettlementObject.uuid">
                    <div fxLayout="row" fxLayoutGap="15px">
                      <span class="log-counter" fxFlex="5">{{i+1}}.</span>
                      <app-detail fxFlex="45" *ngIf="items.log?.createdAt" header="Data wysłania">
                        {{items.log?.createdAt | date:'y-MM-dd HH:mm:ss'}}
                      </app-detail>
                      <app-detail fxFlex="50" *ngIf="items?.log.user" header="Użytkownik">
                        <a class="default-link" [routerLink]="['/uzytkownicy/szczegoly', items.log.user.uuid]">{{items.log.user.firstName}} {{items.log.user.lastName}}</a>
                      </app-detail>
                    </div>
                  </ng-container>
                </ng-container>
              </ng-container>
            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" *ngFor="let commissionContractSettlement of commissionSettlementObject.contractSettlements;">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row" fxLayoutGap="15px">
              <h3 fxFlex="50">Umowa {{commissionContractSettlement.contract?.number}}</h3>

              <div fxFlex="50" fxLayoutAlign="end center" >
                <button
                  (click)="sendReport(commissionContractSettlement)"
                  [disabled]="!(userPermissions | async).settlement.read_report
                  || commissionSettlementObject?.status?.key === COMMISSION_SETTLEMENT_STATUS_NEW
                  || commissionSettlementObject?.status?.key === COMMISSION_SETTLEMENT_STATUS_TO_GENERATE"
                  mat-raised-button color="primary" class="send"
                ><mat-icon>send</mat-icon> <span> Wyślij rozliczenie</span></button>
              </div>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="Umowa"
                          [value]="commissionContractSettlement.contract.type.name + ' (nr: ' + commissionContractSettlement.contract.number + '), '
                          + commissionContractSettlement.contract.status.name"
                          [link]="commissionContractSettlement.contract ? ['/umowy/szczegoly', commissionContractSettlement.contract.uuid] : undefined">
              </app-detail>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <app-detail fxFlex="33" header="Firma">
                {{commissionContractSettlement.contract?.company?.name}}
              </app-detail>
              <app-detail fxFlex="33" header="Suma inkaso">
                {{(commissionContractSettlement.totalCollection === null ? 0 : commissionContractSettlement.totalCollection) | number:'1.2-2'}} zł
              </app-detail>

              <app-detail fxFlex="33" header="Suma prowizji">
                {{(commissionContractSettlement.totalCommission === null ? 0 : commissionContractSettlement.totalCommission) | number:'1.2-2'}} zł
              </app-detail>
            </div>
            <div fxLayout="column">
              <ng-container *ngFor="let element of logs">
                <ng-container *ngFor="let items of element.items; let i = index">
                  <ng-container *ngIf="items.log.entityId === commissionContractSettlement.uuid">
                      <div fxLayout="row" fxLayoutGap="15px">
                        <span class="log-counter" fxFlex="5">{{i+1}}.</span>
                        <app-detail fxFlex="45" *ngIf="items.log?.createdAt" header="Data wysłania">
                        {{items.log?.createdAt | date:'y-MM-dd HH:mm:ss'}}
                        </app-detail>
                        <app-detail fxFlex="50" *ngIf="items?.log.user" header="Użytkownik">
                          <a class="default-link" [routerLink]="['/uzytkownicy/szczegoly', items.log.user.uuid]">{{items.log.user.firstName}} {{items.log.user.lastName}}</a>
                        </app-detail>
                      </div>
                  </ng-container>
                </ng-container>
                </ng-container>
            </div>
          </mat-card>
        </div>
      </div>

    </div>

    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">

      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Kwoty</h3>
            </div>

            <div fxLayout="row">
              <app-detail
                fxFlex="100" header="Suma inkaso"
              >
                {{(commissionSettlementObject.totalCollection === null ? 0 : commissionSettlementObject.totalCollection) | number:'1.2-2'}} zł
              </app-detail>
            </div>

            <div fxLayout="row">
              <app-detail
                fxFlex="100" header="Suma prowizji"
              >
                {{(commissionSettlementObject.totalCommission === null ? 0 : commissionSettlementObject.totalCommission) | number:'1.2-2'}} zł
              </app-detail>
            </div>

            <div fxLayout="row">
              <app-detail
                fxFlex="100" header="Suma inkaso Proama"
              >
                {{(commissionSettlementObject.totalProamaCollection === null ? 0 : commissionSettlementObject.totalProamaCollection) | number:'1.2-2'}} zł
              </app-detail>
            </div>

            <div fxLayout="row">
              <app-detail
                fxFlex="100" header="Suma inkaso MTU komunikacja"
              >
                {{(commissionSettlementObject.totalMtuMotorCollection === null ? 0 : commissionSettlementObject.totalMtuMotorCollection) | number:'1.2-2'}} zł
              </app-detail>
            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" *ngFor="let threshold of commissionSettlementObject.thresholds">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Próg aneksu - {{threshold.thresholdDictionary.name}}</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <app-detail
                fxFlex="50" header="TU"
                [value]="threshold.thresholdDictionary.insuranceCompany?.name"
                [link]="['/tu/szczegoly', threshold.thresholdDictionary.insuranceCompany?.id]"
              ></app-detail>

              <app-detail
                fxFlex="50" header="Importer"
                [value]="threshold.thresholdDictionary.importer?.name"
              ></app-detail>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <app-detail
                fxFlex="50" header="Suma inkaso"
              >
                {{(threshold.totalCollection === null ? 0 : threshold.totalCollection) | number:'1.2-2'}} zł
              </app-detail>

              <app-detail
                fxFlex="50" header="Liczba polis"
              >
                {{threshold.policiesCount}}
              </app-detail>
            </div>

          </mat-card>
        </div>
      </div>
      <mat-card>
        <div fxLayout="row">
          <h3>Saldo</h3>
        </div>
        <ng-container *ngFor="let commissionContractSettlement of commissionSettlementObject.contractSettlements;">
          <ng-container *ngIf="commissionContractSettlement.contractBalance !== null">
            <div fxLayoutGap="15px" fxLayout="column" >
              <div fxFlex="100" class="mb-0"><h4 class="mb-0" >Saldo do: {{commissionContractSettlement.contract.type.name}} (nr: {{commissionContractSettlement.contract.number}}), {{commissionContractSettlement.contract.status.name}}</h4> </div>
                <div fxLayout="row"  fxLayoutGap="15px" >
                  <app-detail fxFlex="25" header="Początkowe" [value]=""> {{(commissionContractSettlement.contractBalance?.initialBalanceNet === null ? 0 : commissionContractSettlement.contractBalance?.initialBalanceNet) | number:'1.2-2'}} zł
                  </app-detail>
                  <app-detail fxFlex="25" header="Do wypłacenia" [value]="">{{(commissionContractSettlement.contractBalance?.toPayNet === null ? 0 : commissionContractSettlement.contractBalance?.toPayNet) | number:'1.2-2'}} zł
                  </app-detail>
                  <app-detail fxFlex="25" header="Wypłacono" [value]="">{{(commissionContractSettlement.contractBalance?.paid === null ? 0 : commissionContractSettlement.contractBalance?.paid) | number:'1.2-2'}} zł
                  </app-detail>
                  <app-detail fxFlex="25" header="Ogólne" [value]="">{{(commissionContractSettlement.contractBalance?.totalCommission === null ? 0 : commissionContractSettlement.contractBalance?.totalCommission) | number:'1.2-2'}} zł
                  </app-detail>
                </div>
            </div>
          </ng-container>
        </ng-container>
      </mat-card>
    </div>
  </div>
</div>
